import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      token: null,
      base64Image: null,
      isThesisActivated: false,
      userId: null,
      role: null,
      nitificationCount: 0,
    };
  },
  mutations,
  actions,
  getters,
};
